
import { Component, Vue } from 'vue-property-decorator'
import AdService from '@/biz/service/System/AdService'

@Component
export default class ViewSystemAdIndex extends Vue {
  private Service = AdService
}
